import styles from './CautionBox.module.scss';
import {useFormLabels} from '@/hooks/help/index';

const CautionBox = () => {
  const {cautionTitle} = useFormLabels();

  return (
    <div className={styles.CautionWrapper}>
      <div className={styles.CautionSection}>
        <strong className={styles.CautionTitle}>{cautionTitle}</strong>
        <ul className={styles.CautionList}>
          <li>
            유저상담 업무를 처리하기 위해 최소한의 개인정보만을 수집하고
            있습니다.
          </li>
          <li>
            고객센터로 문의/신고 시 유저님께서 추가로 입력하시는 개인정보가 있을
            수 있습니다.
          </li>
          <li>
            위의 개인정보 수집 이용에 대한 동의를 거부할 권리가 있으며, 거부 시
            요청 처리에 제한이 있을 수 있습니다.
          </li>
        </ul>
      </div>

      {/* 개인정보와 수집항목 및 이용목적 */}
      <div className={styles.CautionSection}>
        <span className={styles.CautionSubtitle}>
          개인정보와 수집항목 및 이용목적
        </span>
        <ul className={styles.CautionSubList}>
          <li>- 수집항목 : 아이디, 이메일</li>
          <li>- 이용목적 : 유저 불만 또는 분쟁 처리 해결을 위함</li>
        </ul>
      </div>

      {/* 개인정보의 보유 및 이용기간 */}
      <div className={styles.CautionSection}>
        <span className={styles.CautionSubtitle}>
          개인정보의 보유 및 이용기간
        </span>
        <ul className={styles.CautionSubList}>
          <li>
            - 보관목적 : 문의 접수 및 유저 불만 해결을 위해 일정 기간 보관
            됩니다.
          </li>
          <li>- 보관기간 : 3년</li>
        </ul>
      </div>
    </div>
  );
};

export default CautionBox;
